export default __webpack_public_path__ + "static/media/gilroy-regular.31d54a4b.woff";